import { Pipe } from '@angular/core';
import { ViewportSize } from './viewport-size';
import { DomSanitizer } from '@angular/platform-browser';

interface ApiImage {
    urls: any;
}

/**
 * Takes an API image (in the form {urls: {xs: 'https://...', sm: 'https://...'} } )
 * and chooses the best size based on the current screen size.
 */
@Pipe({ name: 'responsiveBackground' })
export class ResponsiveBackgroundPipe {
    constructor(
        private viewportSize : ViewportSize,
        private domSanitizer : DomSanitizer
    ) {
    }

    transform(value : ApiImage, widthFactor : number = 1) {

        // If its invalid, return a blank gif
        if (!value.urls)
            return this.domSanitizer.bypassSecurityTrustStyle('url(data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==)');

        let assetSize = this.viewportSize.selectAssetSize(widthFactor);

        // Return the appropriate size URL, or if the asset does not 
        // have the needed size, return the absolute smallest (because this 
        // needs to be handled by a developer)

        return this.domSanitizer.bypassSecurityTrustStyle(
            `url(${value.urls[assetSize] || value.urls['xs']})`
        );
    }
}